export const getRemoteLoginAskPath = () => "/api/remote_login/ask";

export const getRemoteLoginStatusPath = (statusKey: string) =>
  `/api/remote_login/status/${statusKey}`;

export const getRemoteLoginAuthorizePath = () => "/api/remote_login/authorize";

export const getRemoteLoginPreauthorizePath = () =>
  "/api/remote_login/preauthorize";

export const getRemoteLoginWebviewTokenPath = () =>
  "/api/remote_login/webview_token";

export const getUserStatusPath = () => "/api/user_status";
export const getTeamAppCameraPath = (teamId: string, platform: string) =>
  `/api/team/${teamId}/app_camera?platform=${platform}`;

export const getTelemetryPath = () => "/api/logging/send_telemetry";

export const getStreamHealthStatsPath = (teamId: string) =>
  `/api/stream_health/${teamId}`;

export const getUserPath = (userId?: string) =>
  userId ? `/api/user/${userId}` : "/api/user";

export const tsPostToken = '/v2/3p/teamsnap/access_token'

export * from "./generated/apis/api/apis";
